module.exports = "/usb-micro9f0988f43cd6d431c4a6da97d5c61750.jpg";